import React from 'react';
import ArticleCard from '../components/ArticleCard';
import SectionHeader from '../components/SectionHeader';
import { SectionData } from '../types/types';

interface CategoryTypeCProps {
  articlesData: any[]; // Adjust the type according to your data structure
  sectionDatas: SectionData;
}

const CategoryTypeC: React.FC<CategoryTypeCProps> = ({ articlesData, sectionDatas }) => {
  const isExternal = sectionDatas.linkIcon === 'external';

  return (
    <div className="react-block__type-c react-block__type-c--dark">
      <div className="container">
        {sectionDatas && (
          <SectionHeader
            title={sectionDatas.title}
            linkLabel={sectionDatas.sectionLinkText}
            url={sectionDatas.sectionUrl}
            hasPreIcon={sectionDatas.showIcon}
            isExternal={isExternal}
            iconUrl={sectionDatas.iconUrl}
            hasTitleLink={sectionDatas.hasTitleLink}
            hideHeader={sectionDatas.hideHeader}
          />
        )}
        <div className="react-block__card-container react-block__card-container--type-c">
          {articlesData &&
            articlesData.length > 0 &&
            articlesData.map((article, index) => <ArticleCard key={index} article={article} cardType={'small'} />)}
        </div>
      </div>
    </div>
  );
};

export default CategoryTypeC;
